export default __webpack_public_path__ + "static/media/Curvet6.5.15d9e44c.svg";